import { all, call, put, takeEvery } from 'redux-saga/effects';
import { request } from '../../common/util/RestClient';
import envConfig from '../../config';
import SUCCESS_MESSAGES from '../../common/constants/SuccessMessagesConstants';
import {
  createFilteredView,
  deleteFilteredView,
  editFilteredView,
  fetchFilteredViews,
  fetchFilteredViewsByType,
  selectFilteredView,
} from '../routines/filteredViewsRoutines';

const FILTER_MANAGEMENT_BASE_URL = `${envConfig.APIG_URL}filter-management`;

function* fetchFilteredViewsSaga() {
  try {
    const url = `${FILTER_MANAGEMENT_BASE_URL}/filtered-views`;
    const response = yield call(request, url);
    yield put(fetchFilteredViews.success(response.data || []));
  } catch (error) {
    yield put(fetchFilteredViews.failure({ error }));
  } finally {
    yield put(fetchFilteredViews.fulfill());
  }
}
function* fetchFilteredViewsByTypeSaga(payload) {
  try {
    const { selected, type, skipSelect } = payload?.payload || {};
    const url = `${FILTER_MANAGEMENT_BASE_URL}/filtered-views/${type}`;
    const response = yield call(request, url);
    yield put(
      fetchFilteredViewsByType.success({ filters: response.data, type })
    );

    if (!skipSelect) {
      yield put(selectFilteredView.trigger({ type, id: selected }));
    }
  } catch (error) {
    yield put(fetchFilteredViewsByType.failure({ error }));
  } finally {
    yield put(fetchFilteredViewsByType.fulfill());
  }
}

function* createFilteredViewSaga({ payload }) {
  try {
    const url = `${FILTER_MANAGEMENT_BASE_URL}/filtered-views`;
    const config = {
      method: 'POST',
      payload,
    };
    const { data } = yield call(request, url, config);
    yield put(
      createFilteredView.success({
        successMessage: SUCCESS_MESSAGES.CREATE_FILTERED_VIEW,
      })
    );

    yield put(
      fetchFilteredViewsByType.trigger({
        selected: data.viewId,
        type: data.type,
      })
    );
  } catch (error) {
    yield put(createFilteredView.failure({ error }));
  } finally {
    yield put(createFilteredView.fulfill());
  }
}

function* editFilteredViewSaga({ payload }) {
  try {
    const { viewId, filters } = payload;
    const url = `${FILTER_MANAGEMENT_BASE_URL}/filtered-views/${viewId}`;
    const config = {
      method: 'PUT',
      payload: { filters },
    };
    const { data } = yield call(request, url, config);
    yield put(
      editFilteredView.success({
        successMessage: SUCCESS_MESSAGES.UPDATE_FILTERED_VIEW,
      })
    );
    yield put(
      fetchFilteredViewsByType.trigger({
        selected: viewId,
        type: data.type.toLowerCase(),
      })
    );
  } catch (error) {
    yield put(editFilteredView.failure({ error }));
  } finally {
    yield put(editFilteredView.fulfill());
  }
}

function* deleteFilteredViewSaga({ payload }) {
  try {
    const { viewId, type } = payload;
    const url = `${FILTER_MANAGEMENT_BASE_URL}/filtered-views/${viewId}`;
    const config = {
      method: 'DELETE',
      payload: {},
    };
    yield call(request, url, config);
    yield put(
      deleteFilteredView.success({
        successMessage: SUCCESS_MESSAGES.DELETE_FILTERED_VIEW,
      })
    );
    yield put(
      fetchFilteredViewsByType.trigger({
        selected: null,
        type: type.toLowerCase(),
      })
    );
  } catch (error) {
    yield put(deleteFilteredView.failure({ error }));
  } finally {
    yield put(deleteFilteredView.fulfill());
  }
}

export default function* root() {
  yield all([
    takeEvery(fetchFilteredViews.TRIGGER, fetchFilteredViewsSaga),
    takeEvery(fetchFilteredViewsByType.TRIGGER, fetchFilteredViewsByTypeSaga),
    takeEvery(editFilteredView.TRIGGER, editFilteredViewSaga),
    takeEvery(createFilteredView.TRIGGER, createFilteredViewSaga),
    takeEvery(deleteFilteredView.TRIGGER, deleteFilteredViewSaga),
  ]);
}
